import { Intervention } from '@/app/components/action-plan/types';
import apiClient from '../client/api';
import { GetInterventions } from './interventions.repository';

export type GetActionPlan = {
  interventions: Intervention[];
  potentialRiskDecrease: number;
};
type SaveInterventionsPayload = {
  ids: string[];
};

async function get(): Promise<GetActionPlan> {
  const res = await apiClient.get('/action-plans/current');
  return res.data;
}

async function put(payload: SaveInterventionsPayload): Promise<GetInterventions> {
  const res = await apiClient.put('/action-plans/current', payload);
  return res.data;
}

export default { get, put };
